import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectKudouhoushiki from './../../components/site/select_kudouhoushiki'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectKudouhoushiki: state.searchFormCondition.selectKudouhoushiki,
})

const SelectKudouhoushikiContainer = connect(mapStateToProps, mapDispatchToProps)(SelectKudouhoushiki)

export default SelectKudouhoushikiContainer
